import AdminResources from "../../components/Programming/AdminResources";

const Resources = () => {
     return(
          <AdminResources />
     )
}

export default Resources